import React from 'react';

const WithChildFunction = (fn) => (Wrapped) => {
    return (props) => {
        return <Wrapped {...props}>{fn}</Wrapped>;
    };
};

export default WithChildFunction;
